import EditPage from './edit-page';
export default EditPage;